import { RouterStore } from 'mobx-react-router';

export class RouterModel extends RouterStore {}